
export enum TipoMensaje {
    INFO = 'INFO',
    WARNING = 'WARNING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    DEBUG = 'DEBUG'
}

export class Mensaje {
    public codigo: string;
    public texto: string;
    public contexto: string;
    public tipo: TipoMensaje;
}
